import { render, staticRenderFns } from "./ModelCreateBrands.vue?vue&type=template&id=1e839664&scoped=true&"
import script from "./ModelCreateBrands.vue?vue&type=script&lang=js&"
export * from "./ModelCreateBrands.vue?vue&type=script&lang=js&"
import style0 from "./ModelCreateBrands.vue?vue&type=style&index=0&id=1e839664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e839664",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VIcon,VTextField})
